import axios from 'axios';

const state= {
    Pages:{
        page:1,
        total:0,
        limit:50,
        maxPage: 1
    },
    Selected: false
};

const getters = {
    Pages : (state) => state.Pages,
    Selected : (state) => state.Selected
};

const actions = {

};

const mutations = {
    setPages (state,pages) {
        state.Pages.page = pages.page;
        state.Pages.total = pages.total;
        state.Pages.limit = pages.limit;
        state.Pages.maxPage = Math.ceil(pages.total/pages.limit);
    },
    setSelected (state,selected) {
        state.Selected = selected;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}